










































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import ProductMigrationLogState from '@/components/Products/ProductMigrations/ProductMigrationLogState.vue';

@Component({ name: 'ProductMigrationLog', components: { ProductMigrationLogState } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.productMigrations.fields.status'), width: "15%" },
        { text: this.$t('pageText.productMigrations.fields.logAccount'), width: "20%" },
        { text: this.$t('pageText.productMigrations.fields.logMessage'), width: "35%" },
        { text: this.$t('pageText.productMigrations.fields.createdAt'), width: "15%" },
        { text: this.$t('pageText.productMigrations.fields.updatedAt'), width: "15%" },
    ];
    productMigrationLogPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productMigrationLogPage = +page;
        }
    }

    async beforeMount() {
        await ProductMigrationModule.getProductMigrationLog(this.productMigrationLogPage);
    }

    @Watch('productMigrationLogPage')
    async onProductMigrationLogPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.productMigrationLogPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.productMigrationLogPage}` } });
        }
        // Get new product migration logs
        await ProductMigrationModule.getProductMigrationLog(this.productMigrationLogPage);
    }

    get productMigrationLog() {
        return ProductMigrationModule.productMigrationLog;
    }

    get totalProductMigrationLogPages() {
        return ProductMigrationModule.totalProductMigrationLogPages;
    }

    get loading() {
        return ProductMigrationModule.loadingMigrationLog;
    }

    get pageSize() {
        return ProductMigrationModule.pageSize;
    }

}
